import {
  processImageByAli,
  processVideoByAli,
  processImageByQiniu,
  processVideoByQiniu,
} from '@/base-components/image/lib/imageUtil'
import { CDNType, ImageOptions } from '@/base-components/image/lib/type'
const getHost = (src: string): CDNType => {
  if (!src) return ''

  if (src.indexOf('.poizon.com') > -1) {
    return 'ali'
  }
  if (src.indexOf('du.hupucdn.com') > -1) {
    return 'qiniu'
  }
  return ''
}

export const cdnSrc = (src: string, options, type = 'image') => {
  const processSrc = (cdn: any, options: any, type: any, isGif: boolean) => {
    let q = ''
    if (cdn === 'ali') {
      switch (type) {
        case 'image':
          q += '?x-oss-process=image'
          q += processImageByAli(options as Array<ImageOptions>, isGif)
          break
        case 'video':
          q += '?x-oss-process=video'
          q += processVideoByAli(options as Array<ImageOptions>)
          break
      }
    } else if (cdn === 'qiniu') {
      switch (type) {
        case 'image':
          q += '?imageMogr2'
          q += processImageByQiniu(options as Array<ImageOptions>, isGif)
          break
        case 'video':
          q += '?vframe'
          q += processVideoByQiniu(options as Array<ImageOptions>)
          break
      }
    }
    return q
  }

  const transformSrc = (src: string, options?: Array<ImageOptions>) => {
    // 检查传入的options
    if (Object.prototype.toString.call(options) !== '[object Array]') return src

    if (options!.length === 0) return src

    // 获取图片的cdn厂商
    const cdn = getHost(src)

    if (!cdn) return src

    // 删除query
    src = src.replace(/\?.*/, '')

    // 处理图片
    const isGif = src.toLowerCase().endsWith('.gif')

    src += processSrc(cdn, options, type, isGif)

    return src
  }
  // 这里因为没有严格的限定所以经常会出问题，现在先兼容单个对象过来
  if (typeof options === 'object' && !Array.isArray(options)) {
    options = [options]
  }

  return transformSrc(src, options)
}

export const cdnSrcResize = (src: string, width: number, rate = 3) => {
  return cdnSrc(src, { width: width * rate, mode: 'resize' })
}
